module.exports = __webpack_public_path__ + "img/image158.39db42da.jpg";